var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-TeacherEvaluateView"},[_c('el-row',{staticClass:"page_content"},[_c('h1',{staticClass:"head_title"},[_vm._v("教师评价")]),_vm._v("\n        "+_vm._s(_vm.dataInfo)+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b4c6e60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/teacherEvaluate/TeacherEvaluateView.vue
// module id = null
// module chunks = 